import type { ApplicationRepository } from '#/domain/application/ApplicationRepository'
import type { Application } from '#/domain/application/Application'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainList, type ApplicationResponseDto } from './ApplicationDto'

export class HttpApplicationRepository implements ApplicationRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(): Promise<Application[]> {
    const raw = await this.http.get<ApplicationResponseDto[]>('v1/application')
    return toDomainList(raw)
  }
}
